import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useConfirmPlan } from "../../../../hooks/queries/plans";
import { useNavigate } from "@shopify/app-bridge-react";
import { Page, Card, Spinner } from "@shopify/polaris";
import { Loading } from "@shopify/app-bridge-react";
import { useTranslation } from "react-i18next";

export default function PlanConfirmation() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Get the url search params as an object
  const searchParams = new URLSearchParams(useLocation().search);
  const chargeId = searchParams.get("charge_id");
  const type = searchParams.get("type");

  const { isError, mutate } = useConfirmPlan({
    onSuccess: (data) => {
      const { upgrade } = data;
      navigate(`/settings/plan?upgrade=${upgrade}`, {
        replace: true,
        target: "APP",
      });
    },
  });

  // Confirm plan on mount
  useEffect(() => {
    if (!chargeId || !type) {
      navigate("/settings/plan", { replace: true, target: "APP" });
      return;
    }
    mutate({ chargeId, type });
  }, []);

  if (isError) return <p>{t("settings.plan.confirmation.error")}</p>;

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Loading />
      <Spinner size="large" />
    </div>
  );
}
